import { createTextFunctions } from '@hilma/i18n';
import { Language } from '@hilma/forms';

export const { createI18n, createI18nText  } = createTextFunctions(Language)